export default "__VITE_ASSET__DkH15oOw__"